/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"HeaderLoyaltyButton":"HeaderLoyaltyButton_6lGP2","downgradeStatus":"downgradeStatus_FumP5","info":"info_-KIge"};